import uiRouter from '@uirouter/angularjs';
import angular from 'angular';

export const ReportsListView = angular
  .module('acme.view.application.reports.list', [
    uiRouter,
    'ui.bootstrap',
    'acme.view.application.reports.list.controllers',
  ])
  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const reportsList = {
      name: 'application.reports.list',
      url: '/list',
      views: {
        'subview-main': {
          controller: 'ReportsListController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/reports/list/list.tpl.html',
        },
      },
      data: {
        pageTitle: 'Reports',
        permissions: ['REPORTS_VIEW'],
        enablePreferences: true,
      },
    };

    $stateProvider.state(reportsList);
  }).name;
